import { useState, useEffect, useRef } from 'react';

const SYMBOLS = ['BTCUSD', 'ETHUSD', 'SOLUSD', 'BNBUSD', 'XRPUSD'];
const API_URL = 'https://api.india.delta.exchange/v2/tickers';

const useLivePrices = () => {
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const prevPrices = useRef({});

  const fetchPrices = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      if (data.result && Array.isArray(data.result)) {
        const filtered = {};
        data.result.forEach((ticker) => {
          if (SYMBOLS.includes(ticker.symbol)) {
            const prev = prevPrices.current[ticker.symbol];
            const curr = parseFloat(ticker.close || ticker.mark_price || 0);
            filtered[ticker.symbol] = {
              symbol: ticker.symbol,
              price: curr,
              changePct: parseFloat(ticker.change_percent || 0),
              change: parseFloat(ticker.change || 0),
              high: parseFloat(ticker.high || 0),
              low: parseFloat(ticker.low || 0),
              direction: prev ? (curr > prev.price ? 'up' : curr < prev.price ? 'down' : 'same') : 'same',
            };
          }
        });
        prevPrices.current = { ...prevPrices.current, ...filtered };
        setPrices(filtered);
        setError(null);
      }
    } catch (err) {
      setError('Live prices temporarily unavailable');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 10000);
    return () => clearInterval(interval);
  }, []);

  return { prices, loading, error };
};

export default useLivePrices;